import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import type { Graph, Product } from 'schema-dts'
import type { EventDescription } from '~/composables/types/event'

const useKitProductSchema = (kits: EventDescription[] = undefined): any => {
  const schema = ref<Graph | undefined>(undefined)
  const script = computed(() => ({
    type: 'application/ld+json',
    innerHTML: schema.value,
  }))
  const fullLocalizedUrl = useFullLocalizedUrl()

  const createSchema = (): Product[] => {
    return kits.map((kit) => {
      dayjs.extend(utc)
      dayjs.extend(timezone)

      const obj = {
        '@type': 'Product',
        name: eventGetters.getTitle(kit),
        url: fullLocalizedUrl(`/k/${eventGetters.getPermalink(kit)}/`),
        image: eventGetters.getGallery(kit).map((x) => x.cropped),
        description: eventGetters.getSubtitle(kit),
        offers: {
          '@type': 'Offer',
          availability: 'InStock',
          url: fullLocalizedUrl(`/k/${eventGetters.getPermalink(kit)}/`),
          price: eventGetters.getDefaultPriceAmount(kit) / 100,
          priceCurrency: eventGetters.getDefaultPriceCurrency(kit),
          priceSpecification: eventGetters.getSchemaPriceSpecification(kit),
        },
        brand: {
          '@type': 'Brand',
          name:
            supplierGetters.getName(eventGetters.getSupplier(kit)) ||
            kit?.supplier,
          url: fullLocalizedUrl(
            `/p/${supplierGetters.getPermalink(eventGetters.getSupplier(kit))}`
          ),
        },
      }

      return obj
    })
  }

  schema.value = { '@context': 'https://schema.org', '@graph': createSchema() }

  return {
    schema,
    script,
  }
}

export default useKitProductSchema
